module.exports = __webpack_public_path__ + "assets/normal/images/share8.8016849d.png";